import { ProductType } from '@reward-platform/ancillaries-schemas/common'

export const GTMChannels = {
  FLIGHTS: 'flights',
  EXPERIENCES: 'experiences',
  HOTELS: 'hotels',
  CAR_HIRE: 'car_hire',
} as const

export const getGtmChannelByProductType = (
  productType: ProductType
): (typeof GTMChannels)[keyof typeof GTMChannels] => {
  switch (productType) {
    case 'HOTEL':
      return GTMChannels.HOTELS
    case 'CAR_HIRE':
      return GTMChannels.CAR_HIRE
    case 'EXPERIENCE':
      return GTMChannels.EXPERIENCES
    default:
      return GTMChannels.FLIGHTS
  }
}

export const getGtmChannelFromUrlPath = (path: string) => {
  if (path.includes('/hotels') || path.includes('tab=hotels')) {
    return GTMChannels.HOTELS
  }
  if (path.includes('/cars') || path.includes('tab=carhire')) {
    return GTMChannels.CAR_HIRE
  }
  if (path.includes('/experiences') || path.includes('tab=experiences')) {
    return GTMChannels.EXPERIENCES
  }
  if (path.includes('/flights') || path.includes('tab=flights')) {
    return GTMChannels.FLIGHTS
  }

  return null
}

export const getGtmIsoFromLocale = (locale: string) => {
  const iso = locale.split('-')[1]
  if (iso) {
    return iso.toUpperCase()
  }
  return 'GB'
}
